module.exports = __webpack_public_path__ + "static/media/stockhausen_ganzeteile_2.6f4e0573.png";